import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

const LegalLayout = ({ title, updated, children }) => (
  <div className="min-h-screen bg-background">
    <Header />
    <div className="mx-auto max-w-3xl px-5 py-14 lg:px-8">
      <Link to="/" className="inline-flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-foreground">
        <ArrowLeft className="h-4 w-4" /> Back to home
      </Link>
      <h1 className="mt-4 font-heading text-3xl font-bold tracking-tight text-foreground sm:text-4xl">{title}</h1>
      <p className="mt-2 text-sm text-muted-foreground">Last updated: {updated}</p>
      <div className="mt-8 space-y-6 text-sm leading-relaxed text-foreground [&_h2]:font-heading [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:text-foreground [&_p]:text-muted-foreground [&_li]:text-muted-foreground">
        {children}
      </div>
    </div>
    <Footer />
  </div>
);

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Notice" updated="June 2026">
      <p>
        VisaFlight ("we", "us") provides confirmed airline reservations for visa application documentation. This notice
        explains how we handle the information you provide when placing an order. We treat passport and travel-related
        information as confidential.
      </p>
      <section>
        <h2>Information we collect</h2>
        <p>
          We collect the details you submit through the order form, including your name, email address, WhatsApp number,
          passenger name, travel details and visa information. We do not collect or store your card details — all payments
          are handled securely by Paystack.
        </p>
      </section>
      <section>
        <h2>How we use your information</h2>
        <p>
          Your information is used solely to prepare and deliver your requested airline reservation, to communicate with
          you about your order, and to meet our record-keeping obligations. We do not sell your personal information.
        </p>
      </section>
      <section>
        <h2>Data security</h2>
        <p>
          Order data is stored securely and is not exposed publicly. Access to customer information is restricted to
          authorised personnel. Our website is served over HTTPS.
        </p>
      </section>
      <section>
        <h2>Payment information</h2>
        <p>
          Payments are processed by Paystack. We receive a payment reference and confirmation of a successful transaction;
          we do not receive or store your card number.
        </p>
      </section>
      <section>
        <h2>Contact</h2>
        <p>
          For any privacy questions, or to request access to or deletion of your information, contact us via the WhatsApp
          number shown on our website.
        </p>
      </section>
    </LegalLayout>
  );
}
